import React, { useState } from 'react';

// Orden por columna compartido por las pestañas de Control de Embarques.
// Clic en el encabezado: ascendente → descendente → sin orden (vuelve al orden original).

const vacio = (valor) => valor === null || valor === undefined || valor === '';

const comparar = (a, b) => {
    if (typeof a === 'number' && typeof b === 'number') return a - b;
    return String(a).localeCompare(String(b), 'es', { numeric: true, sensitivity: 'base' });
};

export const useOrdenTabla = () => {
    const [orden, setOrden] = useState({ clave: null, dir: 'asc' });

    const alternarOrden = (clave) => setOrden((actual) => {
        if (actual.clave !== clave) return { clave, dir: 'asc' };
        if (actual.dir === 'asc') return { clave, dir: 'desc' };
        return { clave: null, dir: 'asc' };
    });

    return [orden, alternarOrden];
};

// accesores: { clave: (fila) => valor }. Los valores vacíos quedan siempre al final.
export const ordenarFilas = (filas, orden, accesores) => {
    const accesor = orden.clave ? accesores[orden.clave] : null;
    if (!accesor) return filas;
    const signo = orden.dir === 'asc' ? 1 : -1;
    return filas.slice().sort((x, y) => {
        const a = accesor(x);
        const b = accesor(y);
        if (vacio(a) && vacio(b)) return 0;
        if (vacio(a)) return 1;
        if (vacio(b)) return -1;
        return comparar(a, b) * signo;
    });
};

export const ThOrden = ({ clave, orden, alternarOrden, children }) => {
    const activo = orden.clave === clave;
    const sentido = activo ? (orden.dir === 'asc' ? 'ascending' : 'descending') : 'none';
    return (
        <th aria-sort={sentido}>
            <button
                type="button"
                className={`ce-th-orden${activo ? ' activo' : ''}`}
                onClick={() => alternarOrden(clave)}
            >
                {children}
                <span className="ce-th-flecha" aria-hidden="true">
                    {activo ? (orden.dir === 'asc' ? '▲' : '▼') : '↕'}
                </span>
            </button>
        </th>
    );
};
